// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3HzGd","left":"InfoRow_left__1W-XG"};